import { Views } from "features/enumerations";
import { useEffect } from "react";
import { dispatch } from "store";
import * as autoThunks from 'features/auto-thunks';
import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { get_selected_coherentScreen } from "features/coherentScreen/coherentScreen-slice";
import { get_all_curatedMediaList } from "features/curatedMediaList/curatedMediaList-slice";
import { get_all_curatedSeriesList } from "features/curatedSeriesList/curatedSeriesList-slice";

export default function ModelLoader(props: {}) {
    let claims: any = useSelector(getUserClaims);
    const coherentScreen = useSelector(get_selected_coherentScreen);
    const curatedMediaList_list = useSelector(get_all_curatedMediaList);
    const curatedSeriesList_list = useSelector(get_all_curatedSeriesList);
    function isBrowseMode(): boolean {
        if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
            return false;
        }
        return true;
    }

    useEffect(() => {
        if (claims?.user && !coherentScreen) {
            dispatch(autoThunks.get_current_coherent_screen({ userId: claims?.user }));
        }
    }, [claims?.user]);
    useEffect(() => {
        if (claims?.user && !curatedMediaList_list?.length) {
            dispatch(autoThunks.load_curated_media_list({ ok: false }));
        }
    }, [claims?.user]);
    useEffect(() => {
        if (claims?.user && !curatedSeriesList_list?.length) {
            dispatch(autoThunks.load_curated_series_list({ ok: false }));
        }
    }, [claims?.user]);
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_release_schedule_actions_for_system_schedules({ ok: false }));
        }
    }, [claims?.user, isBrowseMode()])
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_coherent_screen_list_for_system_schedules({ ok: false }));
        }
    }, [claims?.user])
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_media_for_system_schedules({ ok: false }));
        }
    }, [claims?.user])
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_series_for_system_schedules({ ok: false }));
        }
    }, [claims?.user])
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_seasons_for_system_schedules({ ok: false }));
        }
    }, [claims?.user])
    useEffect(() => {
        if (claims?.user && !isBrowseMode()) {
            dispatch(autoThunks.get_coherent_screen_list_for_system_schedules({ ok: false }));
        }
    }, [claims?.user])
    return (
        <></>
    )
}